<template>
  <div class="analytics-content-container">
    <div class="nav-header-container">
      <analytics-nav />
      <v-date-picker
        class="daterange-picker"
        popover-direction="bottom"
        popover-align="right"
        mode="range"
        show-caps
        :drag-attribute="attribute"
        :select-attribute="attribute"
        :value="getDateRange"
        :input-props="{ style: dateInputStyle }"
        @drag="onDragDates"
        @input="onInputDates"
      >
        <div slot="popover" class="popover-content">
          <p>{{ popStartDate }}</p>
          <p>{{ popEndDate }}</p>
          <p class="days-nights">
            <span class="days">
              <svg-icon name="sun" class="vc-sun-o"> </svg-icon>
              {{ popDays }}
            </span>
            <span class="nights">
              <svg-icon name="moon" class="vc-moon-o"> </svg-icon>
              {{ popDays }}
            </span>
          </p>
        </div>
      </v-date-picker>
    </div>
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "analytics",

  components: {
    AnalyticsNav: () => import("@/components/AnalyticsNav"),
    SvgIcon: () => import("@/components/widgets/SvgIcon"),
  },

  data: () => ({
    dateInputStyle:
      "width:220px; text-align:center; border-radius:50px; border:1px solid gray; height:34px;",
    loading: false,
    popStartDate: "",
    popEndDate: "",
    popDays: "",
  }),

  computed: {
    ...mapGetters(["getDateRange", "getIsRequesting"]),

    attribute() {
      let attribute_ = {
        popover: {
          slot: "popover",
        },
      };

      if (this.popDays === 1) {
        attribute_.contentStyle = {
          backgroundColor: "rgb(102, 179, 204)",
          color: "white",
          fontWeight: "400",
          borderRadius: "50%",
        };
      } else {
        attribute_.contentStyle = {
          backgroundColor: "transparent",
          color: "inherit",
          fontWeight: "400",
          borderRadius: "3px",
        };
      }

      return attribute_;
    },
  },

  mounted() {
    this.setPopoverInfo(this.getDateRange);
  },

  methods: {
    onDragDates(e) {
      this.setPopoverInfo(e);
    },

    onInputDates(e) {
      if (!e) {
        return;
      }

      this.$store.commit("SET_DATE_RANGE", e);
    },

    setPopoverInfo(e) {
      if (!e) {
        return;
      }

      this.popStartDate = this.$moment(e.start);
      this.popEndDate = this.$moment(e.end);

      this.popDays = this.popEndDate.diff(this.popStartDate, "day") + 1;

      this.popStartDate = this.popStartDate.format("ddd, MMM D, YYYY");
      this.popEndDate = this.popEndDate.format("ddd, MMM D, YYYY");
    },
  },

  watch: {
    getDateRange(dates) {
      this.setPopoverInfo(dates);
    },
  },
};
</script>

<style lang="scss">
.analytics-content-container {
  height: 100%;
  background-color: #f9f9f9;
  position: static;

  .nav-header-container {
    display: flex;
    justify-content: space-between;
    background-color: #eee;
    position: sticky;
    top: 0px;
    z-index: 2;
  }

  .analytics-info-nav {
    position: fixed;
    bottom: 40%;
    left: 54px;
  }

  .analytics-container {
    padding-top: 54px;
  }

  .daterange-picker {
    margin: 10px 20px;
  }

  .popover-content p {
    margin: 0;
  }

  .days-nights {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 3px;

    .days,
    .nights {
      font-weight: 700;
      display: flex;
      align-items: center;
      &:not(:first-child) {
        margin-left: 13px;
      }
    }

    .vc-sun-o,
    .vc-moon-o {
      margin-right: 5px;
      width: 16px;
      height: 16px;
    }

    .vc-sun-o {
      color: #ffb366;
    }

    .vc-moon-o {
      color: #4d4d64;
    }
  }
}
</style>
